export default Object.freeze([
    {
        name: 'No price',
        value: 'No price'
    },
    {
        name: 'Pricebook',
        value: 'Pricebook'
    },
    {
        name: 'RRP',
        value: 'RRP'
    }
]);
